// Small per-tab memory for view settings (filters, sort order). Storage can be
// blocked, so reads fall back to the default and failed writes are ignored.

export const loadSessionState = (key, fallback) => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(key));
    return stored ? { ...fallback, ...stored } : fallback;
  } catch (error) {
    return fallback;
  }
};

export const saveSessionState = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {}
};
